import { render, staticRenderFns } from "./ProductCategories.vue?vue&type=template&id=e441d358&scoped=true&"
import script from "./ProductCategories.vue?vue&type=script&lang=js&"
export * from "./ProductCategories.vue?vue&type=script&lang=js&"
import style0 from "./ProductCategories.vue?vue&type=style&index=0&id=e441d358&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e441d358",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e441d358')) {
      api.createRecord('e441d358', component.options)
    } else {
      api.reload('e441d358', component.options)
    }
    module.hot.accept("./ProductCategories.vue?vue&type=template&id=e441d358&scoped=true&", function () {
      api.rerender('e441d358', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/AdminPage/ProductsPage/ProductCategories.vue"
export default component.exports